const StateIdentifiers = {
    application: '___application',
    page: '___page',
};
export default StateIdentifiers;
